import type RootState from 'app-components/utils/redux-store/rootState';

import { registerNavigationIntent } from './registry';
import type { NavigationIntent } from './types';

const createStaticIntent = (
  name: string,
  description: string,
  path: string,
): NavigationIntent<Record<string, never>, RootState> => ({
  name,
  description,
  resolver: (_args, _state) => ({
    type: 'navigate',
    payload: { path },
  }),
});

const staticIntents: NavigationIntent<Record<string, never>, RootState>[] = [
  createStaticIntent('dashboard', 'The Dashboard or Overview page.', '/'),
  createStaticIntent(
    'spending_plan',
    'The Spending Plan feature where you can manage budgets based on income and bills.',
    '/spending-plan',
  ),
  createStaticIntent('bills_and_income', 'Bills and Income page for recurring bills and income.', '/upcoming'),
  createStaticIntent('cash_flow', 'Cash Flow page showing predicted cash flows over time.', '/upcoming/cash-flow'),
  createStaticIntent('refund_tracker', 'Refunds feature for expected refunds.', '/upcoming/refund-tracker'),
  createStaticIntent('credit_score', 'Credit Score feature.', '/planning-tools/credit-score'),
  createStaticIntent('retirement_planner', 'Retirement Planner tool.', '/planning-tools/retirement-planner'),
  createStaticIntent('goals', 'Savings Goals feature.', '/goals'),
  createStaticIntent('watchlist', 'Spending Watchlist feature.', '/watchlist'),
  createStaticIntent('investing_portfolio', 'Investing portfolio view.', '/investing?selectedTab=portfolio'),
  createStaticIntent('investing_balances', 'Investing balances view.', '/investing?selectedTab=balances'),
  createStaticIntent('investing_performance', 'Investing performance view.', '/investing?selectedTab=performance'),
  createStaticIntent('investing_transactions', 'Investing transactions view.', '/investing?selectedTab=transactions'),
  createStaticIntent('reports', 'Reports overview page.', '/reports'),
  createStaticIntent('settings', 'Settings page.', '/settings'),
  createStaticIntent('rules', 'Rules page', '/settings/transactionRules'),
];

for (const intent of staticIntents) {
  registerNavigationIntent(intent);
}
